import { createSelector } from '@reduxjs/toolkit';

import { selectAttributeId } from '../options/options.selector';

const selectAlternateData = (state) => state.alternateData;

export const selectAltHurricanes = createSelector(
  selectAlternateData,
  selectAttributeId,
  (data, id) => {
    if (id === 2015) {
      return data.hurricanes;
    } else if (id === 2025) {
      return data.tropStorms;
    }
    return [];
  }
);

export const selectHurricaneCsvData = createSelector(
  selectAlternateData,
  (data) => {
    try {
      return {
        hurricanes: data.hurricanes,
        tropicalStorms: data.tropStorms
      };
    } catch {
      return { hurricanes: [], tropicalStorms: [] };
    }
  }
);

export const selectAdvisories = createSelector(
  selectAlternateData,
  (data) => data.advisories
);
